import React, { useEffect, useState } from 'react';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Axios from 'axios';
import moment from 'moment';
import { trackPromise } from 'react-promise-tracker';
import { Link } from 'react-router-dom';

const Comment = (props) => {
  const comment = props.comment;
  const [commentBody, setCommentBody] = useState(comment.body);
  const [commentUser, setCommentUser] = useState(null);
  const [votes, setVotes] = useState(0);
  const [voteId, setVoteId] = useState('');
  const [upvote, setUpvote] = useState('');
  const [downvote, setDownvote] = useState('');

  useEffect(() => {
    fetchUser();
    trackPromise(getVotes());
  }, []);

  const getVotes = async () => {
    const data = await Axios.get(`https://sleepy-inlet-08384.herokuapp.com/api/votes/comments/${comment._id}`);
    const newVotes = data.data;
    let total = 0;
    // Checks if any votes are from current user. If so, store vote ID.
    newVotes.forEach(vote => {
      if (props.user && vote.user === props.user._id) {
        setVoteId(vote._id);
        vote.vote > 0 ? setUpvote('voted') : setDownvote('voted');
      }
      total += vote.vote;
    })
    setVotes(total);
  }

  const handleUpvote = (e) => {
    if (props.user) {
      if (upvote === 'voted') {
        setUpvote('')
        removeVote();
        setVotes(votes - 1);
      } else {
        setUpvote('voted')
        if (downvote === 'voted') {
          setDownvote('');
          removeVote();
          setVotes(votes + 2);
        } else {
          setVotes(votes + 1);
        }
        addVote(1);
      }
    } else {
      alert('You must be logged in to vote on comments');
    }
  }

  const handleDownvote = (e) => {
    if (props.user) {
      if (downvote === 'voted') {
      setDownvote('')
      removeVote();
      setVotes(votes + 1);
    } else {
      setDownvote('voted')
      if (upvote === 'voted') {
        setUpvote('');
        removeVote();
        setVotes(votes - 2);
      } else {
        setVotes(votes - 1);
      }
      addVote(-1);
    }
    } else {
      alert('You must be logged in to vote on comments');
    }
  }

  const removeVote = async () => {
    const config = {
      headers: {
        'auth-token': props.token
      }
    }
    await Axios.delete(`https://sleepy-inlet-08384.herokuapp.com/api/votes/${voteId}`, config);
  }

  const addVote = async (vote) => {
    const newVote = {
      user: props.user, vote, comment: comment._id
    }
    const config = {
      headers: {
        'auth-token': props.token
      }
    }
    const data = await Axios.post(`https://sleepy-inlet-08384.herokuapp.com/api/votes/`, newVote, config);
    setVoteId(data.data._id);
  }

  const fetchUser = async () => {
    try {
      const data = await Axios.get(`https://sleepy-inlet-08384.herokuapp.com/api/users/${comment.username}`);
      setCommentUser(data.data.user);
    } catch(err) {
      console.log(err);
    }
  }

  const deleteComment = async () => {
    const config = {
      headers: {
        'auth-token': props.token
      }
    }
    const deletedComment = {
      body: "<deleted>"
    }
    await Axios.patch(`https://sleepy-inlet-08384.herokuapp.com/api/comments/${comment._id}`, deletedComment, config)
    setCommentBody("<deleted>");
  }

  return (
    <div className={`comment nested-${props.nested}`}>
      {commentBody !== "<deleted>" &&
      <div className="comment-vote">
        <div className="vote-grid">
          <ArrowDropUpIcon onClick={handleUpvote} className={`vote-arrow ${upvote}`} fontSize="inherit" />
          <p className="upvote-count">{votes}</p>
          <ArrowDropDownIcon onClick={handleDownvote} className={`vote-arrow row-3 ${downvote}`} fontSize="inherit" />
        </div>
        {commentUser && <Link to={`/users/${commentUser._id}`}><p className="comment-user">{commentUser.username}</p></Link>}
      </div>
      }
      {commentBody !== "<deleted>" && 
        <div className="op-header">
            <p className="op-header-light under-user">{comment && moment(comment.date).format('MMMM Do YYYY')}</p>
        </div>
      }
      <p className="comment-body">{commentBody}</p>
      <div className="comment-actions-grid">
        {props.user && commentUser && commentUser.username === props.user.username && commentBody !== "<deleted>" &&
          <button onClick={deleteComment} className="post-btn">Delete</button>
        }
      </div>
    </div>
  );
}

export default Comment;